import {combineReducers} from 'redux';
import rgaDomainValues from './rga-domain-values';

export const getCombinedReducers = () => combineReducers({
    rgaDomainValues
});



// WEBPACK FOOTER //
// ./src/rga/shared/rga-domain-values/reducers/index.js